import { render, staticRenderFns } from "./CreateTileLink.vue?vue&type=template&id=1622f371&scoped=true&"
import script from "./CreateTileLink.vue?vue&type=script&lang=ts&"
export * from "./CreateTileLink.vue?vue&type=script&lang=ts&"
import style0 from "./CreateTileLink.vue?vue&type=style&index=0&id=1622f371&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1622f371",
  null
  
)

export default component.exports